import { cn } from "@/lib/utils";
import { InputHTMLAttributes, forwardRef } from "react";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, icon, className, ...props }, ref) => {
    return (
      <div className="flex flex-col gap-1.5 w-full">
        {label && (
          <label className="text-sm font-medium text-neutral-700">
            {label}
          </label>
        )}
        <div className="relative">
          {icon && (
            <div className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400">
              {icon}
            </div>
          )}
          <input
            ref={ref}
            className={cn(
              "h-11 rounded-lg border border-neutral-200 bg-white",
              "focus:outline-none focus:ring-2 focus:ring-primary-blue/50 focus:border-primary-blue",
              "transition-all placeholder:text-neutral-400",
              icon ? "pl-10 pr-4" : "px-4",
              error && "border-error focus:border-error focus:ring-error/50",
              className
            )}
            {...props}
          />
        </div>
        {error && (
          <span className="text-xs text-error">{error}</span>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";

export { Input };
